var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 441,
    height: 295,
    viewBox: "0 0 441 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2305_19867)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 446,
    height: 295,
    rx: 19.4105,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.9933 98.9132C131.602 103.357 170.318 80.3279 195.53 99.3175C220.965 118.476 210.667 155.211 213.076 184.842C214.871 206.929 213.993 228.046 207.735 249.475C201.07 272.298 192.954 294.386 175.838 312.353C154.601 334.645 131.636 366.288 98.9933 363.62C65.8082 360.907 58.5151 318.279 31.7358 300.574C5.38198 283.149 -36.2855 286.901 -54.1644 262.358C-73.2815 236.116 -67.8428 202.011 -62.6147 171.057C-56.4664 134.655 -58.5112 86.1884 -21.6283 69.7234C16.5658 52.6731 56.7791 93.1602 98.9933 98.9132Z",
    fill: "#FFBB7C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.633 -36.2694C438.031 -41.9282 456.429 0.682915 477.108 24.9781C493.019 43.6713 501.411 65.6195 512.146 87.6954C525.103 114.342 560.09 141.123 546.354 167.377C531.753 195.283 483.434 174.117 457.545 192.053C432.749 209.231 434.741 253.226 406.633 264.173C377.138 275.66 340.409 266.939 315.538 247.361C290.959 228.013 279.697 194.79 278.772 163.523C277.968 136.392 296.355 113.789 310.905 90.8746C321.917 73.5312 340.121 63.8522 352.478 47.44C372.968 20.2245 373.106 -30.2269 406.633 -36.2694Z",
    fill: "#0DBEBE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2305_19867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 446,
    height: 295,
    rx: 19.4105,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard2);
export default __webpack_public_path__ + "static/media/card2.72d6eaa1320a2eff6b1d867693d9cc97.svg";
export { ForwardRef as ReactComponent };